import {
  boardColumns,
  likeClasses,
  likes,
  students,
} from "../../../misc/constants";
import { getRandomFromArray } from "../../../misc/utils";
import { useGlobalUserState } from "../../../stores/user";
import maleStudentProfile from "../../../assets/png/male-student-profile.png";
import options from "../../../assets/svg/options.svg";
import { useRef, useState } from "react";
import { useOutsideClick } from "../../../hooks/ui";
import { boardActions } from "../../../actions/boards";
import Like from "../../../assets/icons/Like";
import { Avatar } from "../../../components/Avatar";

export const BoardTask = ({ task, setTrigger }) => {
  const optionsWrapperRef = useRef(null);
  const userState = useGlobalUserState();
  const userObj = userState.get();
  const user = userObj.user || {};
  const [optionsOpen, setOptionsOpen] = useState(false);
  const like = getRandomFromArray(likes);
  const likeBg = getRandomFromArray(likeClasses);
  const student =
    task.author === user.id
      ? {
          name: `${user.firstname} ${user.lastname}`,
          image: maleStudentProfile,
        }
      : students[task.id % 2];
  useOutsideClick(
    optionsWrapperRef,
    () => setOptionsOpen((o) => (!!o ? false : o)),
    ["options-button"]
  );

  const updateStatus = (status) => async () => {
    const filters = {
      id: task.id,
    };
    const update = {
      status,
    };
    const result = await boardActions.updateBoardTask(filters, update);
    if (result.success) {
      setOptionsOpen(false);
      setTrigger((t) => t + 1);
    }
  };

  return (
    <div className="bg-white p-4 rounded-lg flex flex-col mb-2.5">
      <div className="flex flex-row justify-between items-center">
        <p className="font-medium text-[#1A1A1A] break-all">{task.title}</p>
        <div className="relative ml-2">
          <img
            src={options}
            className="cursor-pointer options-button px-4 py-2"
            onClick={() => setOptionsOpen(true)}
          />
          {optionsOpen && (
            <div
              ref={optionsWrapperRef}
              className="absolute top-1 right-0 bg-white py-3 px-4 rounded-lg flex flex-col min-w-36 shadow-container-1"
            >
              {boardColumns
                .filter((c) => c.label !== task.status)
                .map((column) => (
                  <p
                    className="text-black text-xs font-semibold hover:text-[#42B7CB] cursor-pointer"
                    onClick={updateStatus(column.label)}
                  >
                    {column.label}
                  </p>
                ))}
            </div>
          )}
        </div>
      </div>
      <p className="text-sm text-[#5F6B88] leading-5 line-clamp-3">
        {task.description}
      </p>
      <div className="flex flex-row items-center justify-between mt-3.5">
        <div className="flex flex-row">
          <img src={student.image} className="w-10 h-10" />
          <div className="flex flex-col ml-3">
            <p className="font-medium text-[#5F6B88]">{student.name}</p>
            <p className="text-sm text-[#5F6B88]">Студент</p>
          </div>
        </div>
        <div
          className={`rounded-[4.71px] like-inactive flex flex-row items-center py-[3px] px-[5px] cursor-pointer`}
        >
          <Like additionalStyle="w-[15px] h-[14px] text-black" />
          <p className={`text-black`}>{task.likes.length}</p>
        </div>
      </div>
    </div>
  );
};
